import { render, staticRenderFns } from "./SliceRelatedProducts.vue?vue&type=template&id=3c3fa8a1&lang=pug&"
import script from "./SliceRelatedProducts.vue?vue&type=script&lang=js&"
export * from "./SliceRelatedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports